import { render, staticRenderFns } from "./v-field-edit-text.vue?vue&type=template&id=387e8a46&"
import script from "./v-field-edit-text.vue?vue&type=script&lang=js&"
export * from "./v-field-edit-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports